import { sidepanelSideSign, type SidepanelSide } from '@shared/sidepanel/side'

/** The toast viewport's own horizontal inset — applied to the section, not a class, so the shift math can't drift from it. */
export const TOAST_VIEWPORT_PADDING = 12

/** Breathing room between the panel's visible surface and the nearest toast. */
export const SIDEPANEL_TO_TOAST_GAP = 16

/**
 * How far the toast viewport slides away from the docked panel, in px.
 *
 * Measured off the panel's *visible* surface (`sidepanelVisibleWidth`, i.e. the
 * rendered width minus its transparent inner gutter) rather than the rendered
 * width, so the toast clears the card itself instead of landing inside it.
 * Negative when the panel is docked right, positive when docked left.
 */
export const toastSidepanelShiftX = (visiblePanelWidth: number, side: SidepanelSide): number =>
  -(visiblePanelWidth + SIDEPANEL_TO_TOAST_GAP - TOAST_VIEWPORT_PADDING) * sidepanelSideSign(side)
